// Turns a business's raw report_views (server.py pushes one entry per report
// load, see server.py get_public_report) into a plain "has the prospect
// actually opened it" summary for the admin table — the question the owner
// could not answer before (2026-09-28 request).
//
// is_own_device entries are the owner's own preview/QA opens (report link
// clicked from the admin panel, or opened on a device where the admin token
// is present) — they must never count as a prospect open, same rule the
// backend comment already states for report_events.
export function reportOpenStatus(business) {
  const views = (business?.report_views || []).filter((v) => v && !v.is_own_device);
  if (views.length === 0) return { opened: false, count: 0, lastAt: null };
  const lastAt = views.reduce((latest, v) => (!latest || v.at > latest ? v.at : latest), null);
  return { opened: true, count: views.length, lastAt };
}
